import React from 'react';
import './Styles.scss';
import {Card, CardBody, CardHeader, Col, Collapse, Row} from "reactstrap";
import {Button as SementicBtn, Button, Form, Label, List,Input} from "semantic-ui-react";
import DrpDwn from "../../../../components/Dropdown/Dropdown/DrpDwn";
import TxtAreaLbl from "../../../../components/Input/TextArea/TextAreaLbl";
import {Checkbox, DatePicker, TimePicker, Tooltip} from 'antd';
import Lbl from "../../../../components/Label/Lbl";
import * as common from "../../../../const/Common/CommonFunc";
import Cookies from "js-cookie";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import axios_eventtag from "../../../../axios/axios_eventtag";
import apiConfig from "../../../../axios/axios_api_services";
import TxtLbl from "../../../../components/Input/Input/TxtLbl";
import LabelDropdown from "../../../../components/Dropdown/LabelDropdown/LabelDropdown";
import LabelInput from "../../../../components/Input/LabelInput/LabelInput";
import moment from "moment";
import {MDBDataTable} from "mdbreact";
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
const {RangePicker} = DatePicker;

// function disabledDate(current) {
//   return current && current < moment().startOf("day");
// }

class App extends React.Component {

  state = {
    eventId: 0,
    eventTitle: "",
    eventHasSubEvents: "",
    eventList: [],
    eventOptionList: [],

    subEventSelectionShow: false,
    startDate: "",
    endDate: "",
    subEventId: 0,
    subEventTitle: "",
    subEventOptionList: [],
    subEventSelectedList: [],
    startTime: "",

    notificationTitle: "",
    notificationText: "",
    notificationMail: false,
    notificationApp: false,
    notificationCheckInParticipants: false,
    notificationNoneCheckInParticipants: false,
    notificationApproveParticipants: false,
    notificationPendingParticipants:false,
    notificationForEntireEvent: false,
    notificationSubEventList: [{}],
    name: "",
    description: "",
    message_text_count: 500,
  };

  componentDidMount() {
    this.getAllEvents();
  }

  getAllEvents = () => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let corperateId = this.props.usr_obj.corporates[0].corporateId;
    axios_eventtag.get(apiConfig.CORPORATE_EVENTS({corporateId: corperateId}), {headers: headers})
      .then(async response => {
        if (response.data.success) {
          let firstEventId = response.data.eventList.length !== 0 ? response.data.eventList[0].event_id : '';
          this.setState({
            eventList: response.data.eventList,
            eventId: firstEventId
          });
          this.makeEventOptionList();
          this.props.spinnerHandler(false);
          this.getSubEvents(firstEventId)
        }
      }).catch(async error => {
      let result = await common.checkErrorResponse(error);
      if (result === 1) {
        this.getAllEvents();
      } else {
        this.props.spinnerHandler(false)
      }
    })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  makeEventOptionList = () => {
    let options = [];
    this.state.eventList.map((value, index) => {
      let obj = {
        key: value.event_id,
        value: value.event_id,
        text: value.event_name,
        hassub: value.has_sub_event === true ? 1: 0,
        starttime: value.start_time
      }

      options.push(obj);
    });
    this.setState({
      eventOptionList: options
    });

  };

  onHandleChangeEventSelect = (e, {value}) => {

    // let id = value
    // this.setState({
    //   eventId: id
    // })

    let id = value
    let eventOptionList = this.state.eventOptionList;
    let eventOptionListElement = eventOptionList[id];

    let hasSub = eventOptionListElement.hassub;
    let eventId = eventOptionListElement.key;
    let eventName = eventOptionListElement.text;
    let startTime = eventOptionListElement.starttime;
    let option = [];

      this.setState({
         eventHasSubEvents:hasSub,
         eventId: eventId,
         eventTitle: eventName,
         startTime: startTime,
         subEventSelectedList: [],
      });

    this.getSubEvents(eventId, hasSub)
  };

  getSubEvents = (eventId, hasSubEvents) => {
    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let eventid = eventId;
    axios_eventtag.get(apiConfig.GET_SUBEVENT({event_id: eventid, corporateId: corporateId}), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            subEventOptionList: response.data.subEventList,
          });

          if(!hasSubEvents) {
            let sub = response.data.subEventList[0];
            let arr = [sub.sub_event_id];
            this.setState({
              subEventSelectedList: arr
            });
          }

        } else {
          this.setState({
            subEventOptionList: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getSubEvents(eventId);
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  onHandleChangeSelectSubEvent = (event, value) => {
    let sub_events = this.state.subEventSelectedList;
    let check = event.target.checked;
    let checked_subevent = value

    if(check) {
      sub_events.push(checked_subevent)
    }else {
      let index =sub_events.indexOf(checked_subevent);
      sub_events.splice(index, 1)
    }
    this.setState({
          subEventSelectedList: sub_events
    })
  };

  onHandleChangeNotificationCheckBox = (item) => {
    switch (item) {
      case "EMAIL":
        this.setState({notificationMail: !this.state.notificationMail});
        break;
      case "APP":
        this.setState({notificationApp: !this.state.notificationApp});
        break;
      case "APPROVE":
        this.setState({ notificationApproveParticipants: !this.state.notificationApproveParticipants});
        break;
      case "PENDING":
        this.setState({ notificationPendingParticipants: !this.state.notificationPendingParticipants});
        break;
      case "CHECK-IN":
        this.setState({notificationCheckInParticipants: !this.state.notificationCheckInParticipants});
        break;
      case "NON-CHECK-IN":
        this.setState({notificationNoneCheckInParticipants: !this.state.notificationNoneCheckInParticipants});
        break;
      default:
        break;
    }

  };

  onChangeAction = (event) =>{

    let value = event.target.value;
    event.target.type === "text" ?  this.setState({name: value}) :  this.setState({description: value})

    if(event.target.type === "text") {
      this.setState({name: value})
    } else {

      let count = 500 - value.length;
      if(count < 0) {
        this.setState({
          description: value.substring(0, value.length + count),
          message_text_count: 0
        })
      } else {
        this.setState({
          description: value,
          message_text_count: count
        })
      }
    }

  }

  validateNotification = () => {

    this.state.eventId === 0 ?
      common.notifyMessage("Please Select Event") :
        this.state.eventHasSubEvents ? this.state.subEventSelectedList.length === 0 ? common.notifyMessage("Please Select Sub-Event") :
          this.validateNotification_() :
            this.validateNotification_();
  };
  validateNotification_ = () => {
    this.state.name === "" ?
      common.notifyMessage("Please Enter Notification Title") :
        this.state.description === "" ?
          common.notifyMessage("Please Enter Notification Text") :
          !this.state.notificationMail && !this.state.notificationApp ?
            common.notifyMessage("Please Select Notification Media") :
            !this.state.notificationCheckInParticipants && !this.state.notificationNoneCheckInParticipants && !this.state.notificationPendingParticipants && !this.state.notificationApproveParticipants ?
              common.notifyMessage("Please Select Notification Receiver") :
              this.sendToBackEnd();
  }

  sendToBackEnd = () => {
    const {eventId, subEventSelectedList, name,description, notificationMail, notificationCheckInParticipants,notificationNoneCheckInParticipants,
      notificationApp, notificationApproveParticipants,notificationPendingParticipants} = this.state ;
    const obj = {
      "event_id" : eventId,
      "sub_event_list" : subEventSelectedList,
      "notification_title" : name,
      "notification_text" :description,
      "notification_mail" : notificationMail,
      "notification_app" : notificationApp,
      "notificationCheckInParticipant" : notificationCheckInParticipants,
      "notificationNoneCheckInParticipants": notificationNoneCheckInParticipants,
      "notificationPendingParticipants" : notificationPendingParticipants,
      "notificationApproveParticipants" : notificationApproveParticipants
    }

    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axios_eventtag.patch(apiConfig.SEND_NOTIFICATION({corporateId: corporateId}), obj, {headers: headers})
    .then(response => {
      if (response.data.success) {
        common.warningAlert("Notification set successfully!", 0);
      }
      else {
        common.warningAlert(response.data.message, 1)
      }
      this.clearFeilds()
    })
    .catch(async error => {
      let result = await common.checkErrorResponse(error);
      if (result === 1) {
        this.sendToBackEnd()
      }
    })
    .finally(fin => {
      this.props.spinnerHandler(false);
    });
  };

  clearFeilds = () => {
    this.setState ({
      eventId: "",
      subEventList: "",
      name: "",
      description: "",
      notificationMail: false,
      notificationCheckInParticipants: false,
      notificationNoneCheckInParticipants: false,
      notificationApproveParticipants: false,
      notificationPendingParticipants: false,
      notificationApp: false,
      message_text_count: 500
    })
  };

  render() {

    let events = [];

    if (this.state.eventList.length !== 0) {
      this.state.eventList.map((value, index) => {
        events.push({
          text: value.event_name,
          value: index,
          key: value.event_id,
          hassub: value.has_sub_event === true ? 1:0,
          starttime: value.start_time
        })
      })
    }

    let subEvents= this.state.subEventOptionList.map(( subE, index) => {
    return <List.Item key={subE.sub_event_id}>
       <List.Content floated='right'>
       <Checkbox  className={"mk-block"}
                style= {{marginTop : "12px", marginBottom: "12px"}}
                 value={subE.sub_event_id}
                  onChange={(event)=>this.onHandleChangeSelectSubEvent(event, subE.sub_event_id)}
                 />
      </List.Content>
      <List.Content>
    <List.Header>{subE.name}<Label>{subE.status}</Label></List.Header>
      {moment(subE.start_time).format('YYYY-MM-DD  HH.mm')}
      </List.Content>
    </List.Item>
    })

    return (
      <div className={"set-notification"}>
        <Row>
          <Col xs="12" lg={"6"} md={"12"} className={"padd_grap"}>
            <Card>
              <CardHeader>
                Filter Event
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>
                  <Row>
                    <Col lg={12}>

                      <div>
                        <Form>
                          <Form.Group widths='equal'>
                            <LabelDropdown
                              required
                              className={"select-host"}
                              // loading={host_loader}
                              btnText={"Get Info"}
                              tagText={"Event"}
                              placeholder={"Select or search event"}
                              options={events}
                              value={this.state.event_id}
                              // onSearchChange={this.handleSearchHost}
                              onChange={this.onHandleChangeEventSelect}
                            />

                          </Form.Group>
                          <Form.Group widths='equal'>
                            <Col lg={12}>
                              <LabelInput
                                disable
                                type={"notify"}
                                tagText={"Event Name"}
                                placeholder={"Event Name"}
                                value={this.state.eventTitle}
                              />
                            </Col>
                          </Form.Group>
                          <Form.Group widths='equal'>
                          <Col>
                              <LabelInput
                                disable
                                type={"notify"}
                                tagText={"Event Date"}
                                placeholder={"Event Date"}
                                value={this.state.startTime}
                              />
                          </Col>
                          </Form.Group>
                        </Form>
                        <div>
                            {
                              this.state.eventHasSubEvents === 1 ?
                              <div><Form>
                                  <Form.Group widths='equal'>
                                  <Col>
                                    <div className={"marginTop-10"}>
                                      <i aria-hidden="true" className="check circle icon"></i> Has Sub-Events
                                    </div>
                                  </Col>
                                </Form.Group>
                                </Form>
                              </div>
                                : ""
                            }
                        </div>
                      </div>

                    </Col>
                    <Col lg={12}>
                      {this.state.eventHasSubEvents === 1 ?
                        <List className= {"list"} celled>
                          {subEvents}
                      </List>
                        : ""}
                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>
          </Col>
          <Col xs="12" lg={"6"} md={"12"} className={"padd_grap"}>
            <Card>
              <CardHeader>
                Create Event Notifications
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>
                  <Row>
                    {/*<Col lg ={2}></Col>*/}
                    <Col lg={12}>
                      <Row>
                        <Col lg={12}>
                          <Form>
                            <Form.Group widths='equal'>
                              <TxtLbl
                                required
                                tagText={"Notification Title"}
                                placeholder={"Enter notification title"}
                                value={this.state.name}
                                onChange={this.onChangeAction}
                              />
                            </Form.Group>
                            <Form.Group widths='equal'>
                              <TxtAreaLbl
                                required
                                tagText={"Notification Text"}
                                placeholder={"Enter notification text"}
                                value={this.state.description}
                                onChange={this.onChangeAction}
                              />
                            </Form.Group>
                            <div className={'text-right'}><span>{this.state.message_text_count}</span><span>/ 500</span></div>
                          </Form>
                        </Col>
                        <Col lg={6} md={6}>
                          <Lbl required>Notification Media</Lbl>
                          <Row className={""}>
                            <Col lg={12}>
                              <Checkbox
                                className={"mk-block"}
                                checked={this.state.notificationMail}
                                onChange={() =>this. onHandleChangeNotificationCheckBox("EMAIL")}
                              >
                                E-mail
                              </Checkbox>
                            </Col>
                            <Col lg={12}>
                              <Checkbox
                                className={"mk-block"}
                                checked={this.state.notificationApp}
                                onChange={() =>this. onHandleChangeNotificationCheckBox("APP")}
                              >
                                Mobile App
                              </Checkbox>
                            </Col>
                          </Row>
                        </Col>
                        <Col lg={6} md={6}>
                          <Lbl required>
                            Notification Receiver
                          </Lbl>

                          <Row className={""}>
                            <Col lg={12}>
                              <Checkbox
                                className={"mk-block"}
                                checked={this.state.notificationApproveParticipants}
                                onChange={() =>this. onHandleChangeNotificationCheckBox("APPROVE")}
                              >
                                Approved Participants
                              </Checkbox>
                            </Col>
                            <Col lg={12}>
                              <Checkbox
                                className={"mk-block"}
                                checked={this.state.notificationPendingParticipants}
                                onChange={() =>this. onHandleChangeNotificationCheckBox("PENDING")}
                              >
                                Pending Participants
                              </Checkbox>
                            </Col>
                            <Col lg={12}>
                              <Checkbox
                                className={"mk-block"}
                                checked={this.state.notificationCheckInParticipants}
                                onChange={() =>this. onHandleChangeNotificationCheckBox("CHECK-IN")}
                              >
                                Checked-in Participants
                              </Checkbox>
                            </Col>
                            <Col lg={12}>
                              <Checkbox
                                className={"mk-block"}
                                checked={this.state.notificationNoneCheckInParticipants}
                                onChange={() =>this. onHandleChangeNotificationCheckBox("NON-CHECK-IN")}
                              >
                                None check-in Participants
                              </Checkbox>
                            </Col>
                          </Row>
                        </Col>
                        <Col lg={12} md={12} className={"text-center"}>
                          <Button
                            className="btn-style"
                            onClick={this.validateNotification}
                          >Send</Button>
                        </Col>
                      </Row>
                    </Col>
                    {/*<Col lg ={2}></Col>*/}
                  </Row>
                </CardBody>
              </Collapse>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
  test_alleventobject: state.eventReducer.allEventsObj,
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
